import { useLocalization } from '@/hooks/useLocalization';
import { useWidget } from '@/state/WidgetContext';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { SCREENS } from '@/utils/constants';

export default function WelcomeScreen() {
  const { t } = useLocalization();
  const { goTo } = useWidget();
  const { chooseScenario, contactExpert } = useChat();

  return (
    <BotMessage text={t('welcome.message')}>
      <ScreenOptions>
        <OptionButton variant="primary" onClick={() => chooseScenario('events')}>
          {t('welcome.selectEvent')}
        </OptionButton>
        <OptionButton onClick={() => goTo(SCREENS.CATCHUP)}>
          {t('welcome.howToJoin')}
        </OptionButton>
        {/* <OptionButton onClick={() => goTo(SCREENS.GUIDE)}>
          {t('welcome.downloadGuide')}
        </OptionButton> */}
        <OptionButton onClick={contactExpert}>
          {t('welcome.contactExpert')}
        </OptionButton>
      </ScreenOptions>
    </BotMessage>
  );
}
